import { BellCogOutlineIcon } from './BellCogOutlineIcon';

/**
 * author: Colton Wiscombe
 * id 51BF300C-2921-4364-B362-56E4D81DA629
 * name bell-cog-outline
 * version: 6.7.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/bell-cog-outline.svg
 * tags
 * - Notification 
 * - Settings 
 */
export const BellSettingsOutlineIcon = BellCogOutlineIcon;
export default BellSettingsOutlineIcon